import { gql } from 'urql'

const QueryNotificationsUnreadCount = gql`
  query {
    notificationsUnreadCount
  }
`

export default QueryNotificationsUnreadCount
